/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../styles';

import RadioButton from './RadioButton.js';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    width: 33%;
  }
`;

/**
 * RadioGroup wrapper for radio buttons.
 * Exposes the standard name, value, options, onChange API as other elements
 *
 * Compares group value to option value to check an individual RadioButton
 */
class RadioGroup extends React.Component {

  render() {
    const { options, name, value, disabled, onChange, instanceOrProduct } = this.props;
    return (
      <Wrapper className={this.props.className}>
        {options.map((option, i) => (
          <RadioButton
            instanceOrProduct={instanceOrProduct}
            key={i}
            id={option.id}
            name={name}
            value={option.value}
            checked={option.value === value}
            disabled={Boolean(disabled) || option.disabled}
            text={option.text}
            onChange={onChange}
          />
        ))}
      </Wrapper>
    );
  }
}

export default RadioGroup;
